// extracted by mini-css-extract-plugin
export default {"domainNameFieldWrapper":"EAyUn","error":"lvMR4","captchaFieldWrapper":"EaWDN","inputErrorWrapper":"+JI1L","submitButtonText":"oEyf5","loading":"e3+Yz"};